import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

let cache = null;
let inflight = null;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(cache));

export const fetchProducts = async (force = false) => {
    if (cache && !force) return cache;
    if (!inflight) {
        inflight = axios
            .get(`${API}/api/products`)
            .then((r) => {
                cache = r.data;
                notify();
                return cache;
            })
            .finally(() => {
                inflight = null;
            });
    }
    return inflight;
};

export const refreshProducts = () => fetchProducts(true);

export const useProductAttachments = (key) => {
    const [data, setData] = useState(cache);
    useEffect(() => {
        listeners.add(setData);
        fetchProducts().catch(() => {});
        return () => listeners.delete(setData);
    }, []);
    return data?.[key]?.attachments ?? [];
};

const absolute = (url) => (url ? `${API}${url}` : "");

// Catalogo pubblico = dati statici (src/data) + modifiche dal pannello (foto principale, descrizione breve, nascosto)
// + prodotti aggiunti dal pannello. `toItem` adatta un prodotto custom alla forma usata dalla sezione.
export const useCatalog = (group, staticList, shortField, toItem) => {
    const [data, setData] = useState(cache);
    useEffect(() => {
        listeners.add(setData);
        fetchProducts().catch(() => {});
        return () => listeners.delete(setData);
    }, []);
    if (!data) return staticList;
    const merged = staticList
        .filter((p) => !data[p.key]?.hidden)
        .map((p) => {
            const o = data[p.key];
            if (!o) return p;
            return { ...p, img: o.img ? absolute(o.img) : p.img, [shortField]: o.short || p[shortField] };
        });
    const custom = Object.values(data)
        .filter((d) => d.custom && d.group === group && !d.hidden)
        .sort((a, b) => (a.created_at || "").localeCompare(b.created_at || ""))
        .map((d) => toItem({ ...d, img: absolute(d.img) }));
    return [...merged, ...custom];
};

export const splitParagraphs = (text) => (text || "").split(/\n\s*\n|\n/).map((s) => s.trim()).filter(Boolean);

export const fileUrl = (att, download = false) =>
    `${API}${att.url}${download ? "?download=1" : ""}`;
